"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenu = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _navigation = require("../../context/navigation");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _models = require("../../models");
var _BurgerMenuContent = require("./BurgerMenuContent");
var _BurgerMenuTab = require("./BurgerMenuTab");
var _LazyLinks = require("./Links/LazyLinks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BurgerMenu = ({
  mobilePersonalMenuOutlet
}) => {
  const {
    BurgerMenu: BurgerMenuType,
    AccountSideMenu: AccountSideMenuType
  } = ToggleMenuFlyout.MenuTypes;
  const {
    activeMenu,
    toggleActiveMenu
  } = (0, _navigation.useActiveMenu)();
  const isMobile = (0, _hooks.useIsMobile)();
  const ownerState = {
    isMobile
  };
  const handleTabClick = (0, _react.useCallback)(tabName => {
    const menuType = tabName === _models.BurgerMenuTabNames.ProductsTab ? BurgerMenuType : AccountSideMenuType;
    toggleActiveMenu(menuType);
  }, [AccountSideMenuType, BurgerMenuType, toggleActiveMenu]);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const customerInitials = (0, _hooks.useCustomerInitials)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const isLoggedIn = !isAnonymousUser;
  const isMenuActive = activeMenu === BurgerMenuType || isMobile && activeMenu === AccountSideMenuType;
  const activeTab = activeMenu === BurgerMenuType ? _models.BurgerMenuTabNames.ProductsTab : _models.BurgerMenuTabNames.AccountTab;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onClickOverlay = (0, _react.useCallback)(() => {
    toggleActiveMenu(BurgerMenuType);
  }, [BurgerMenuType, toggleActiveMenu]);
  const slots = (0, _react.useMemo)(() => ({
    backdrop: _mui.Backdrop
  }), []);
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ModalRoot, {
      slots: slots,
      open: isMenuActive,
      onClose: onClickOverlay,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Slide, {
        in: isMenuActive,
        direction: "right",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuRoot, {
          ownerState: ownerState,
          "data-testid": getTestId(_constants.BURGER_MENU_ROOT),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuContainer, {
            "data-testid": getTestId(_constants.BURGER_MENU_CONTAINER),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuTab.BurgerMenuTab, {
              activeTab: activeTab,
              tabName: _models.BurgerMenuTabNames.ProductsTab,
              tabPrefix: _icons.BurgerMenu,
              onTabClick: handleTabClick,
              children: translations.menu
            }), isLoggedIn ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuTab.BurgerMenuTab, {
              activeTab: activeTab,
              tabName: _models.BurgerMenuTabNames.AccountTab,
              tabPrefix: customerInitials ?? '',
              isLoggedIn: isLoggedIn,
              onTabClick: handleTabClick,
              children: translations.myAccount
            }) : null]
          }), activeTab === _models.BurgerMenuTabNames.ProductsTab && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyLinks.LazyLinks, {}), activeTab === _models.BurgerMenuTabNames.AccountTab && !isAnonymousUser ? mobilePersonalMenuOutlet : null]
        })
      })
    });
  }
  if (!isMenuActive) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuRoot, {
    as: "div",
    ownerState: {
      ...ownerState,
      isDesktop: true
    },
    "data-testid": getTestId(_constants.BURGER_MENU_ROOT),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuInner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyLinks.LazyLinks, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuContent.LazyBurgerMenuContent, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Backdrop, {
        open: true,
        "data-testid": getTestId(_constants.BURGER_MENU_BACKDROP),
        sx: {
          position: 'absolute',
          zIndex: '-1',
          width: '100vw',
          height: '100vh'
        },
        onClick: onClickOverlay
      })]
    })
  });
};
exports.BurgerMenu = BurgerMenu;
//# sourceMappingURL=BurgerMenu.js.map